import { render, staticRenderFns } from "./DCReceive.vue?vue&type=template&id=3ca68fbe&scoped=true"
import script from "./DCReceive.vue?vue&type=script&lang=js"
export * from "./DCReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca68fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca68fbe')) {
      api.createRecord('3ca68fbe', component.options)
    } else {
      api.reload('3ca68fbe', component.options)
    }
    module.hot.accept("./DCReceive.vue?vue&type=template&id=3ca68fbe&scoped=true", function () {
      api.rerender('3ca68fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/ReceiveVolume/DCReceive.vue"
export default component.exports